var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.$t("fillInAddressInformation"),
      rightMethod: _vm.onSubmitted,
      medium: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-layout",
              { attrs: { "justify-space-between": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { md5: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "required_field",
                      attrs: {
                        label: _vm.$t("addressName"),
                        rules: [
                          _vm.fieldIsRequired("Site name"),
                          _vm.checkDupSiteName
                        ],
                        "browser-autocomplete": "no",
                        autocomplete: "NoAutocomplete",
                        readonly: !!_vm.address.siteName
                      },
                      model: {
                        value: _vm.site.siteName,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.site,
                            "siteName",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "site.siteName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md5: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "required_field",
                      attrs: {
                        label: _vm.$t("Full name"),
                        rules: [
                          _vm.fieldIsRequired("Full name"),
                          _vm.fieldCharLimit("Full name", 35)
                        ]
                      },
                      model: {
                        value: _vm.site.fullName,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.site,
                            "fullName",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "site.fullName"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-text-field", {
              staticClass: "required_field",
              attrs: {
                label: _vm.$t("addressLine") + " 1",
                id: "Address",
                rules: [
                  _vm.fieldIsRequired("Address"),
                  _vm.fieldCharLimit("Address1", 50)
                ]
              },
              model: {
                value: _vm.site.address1,
                callback: function($$v) {
                  _vm.$set(
                    _vm.site,
                    "address1",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "site.address1"
              }
            }),
            _vm._v(" "),
            _c("v-text-field", {
              attrs: { label: _vm.$t("addressLine") + " 2", id: "Address2" },
              model: {
                value: _vm.site.address2,
                callback: function($$v) {
                  _vm.$set(
                    _vm.site,
                    "address2",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "site.address2"
              }
            }),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { "justify-space-between": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "required_field",
                      attrs: {
                        label: _vm.$t("city"),
                        id: "City",
                        rules: [_vm.fieldIsRequired("City")]
                      },
                      model: {
                        value: _vm.site.city,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.site,
                            "city",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "site.city"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("vite-autocomplete", {
                      attrs: {
                        items: _vm.$store.getters.stateAbbrevs,
                        label: _vm.$t("state"),
                        disabled:
                          (_vm.editMode && !_vm.siteKeyCanEdit) ||
                          _vm.site.countryCode !== "US",
                        id: "addressState"
                      },
                      model: {
                        value: _vm.site.state,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.site,
                            "state",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "site.state"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t("zipCode"),
                        id: "Zip code",
                        disabled: _vm.editMode && !_vm.siteKeyCanEdit
                      },
                      model: {
                        value: _vm.site.zipCode,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.site,
                            "zipCode",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "site.zipCode"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { "justify-space-between": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-text-field", {
                      attrs: { label: _vm.$t("phone") },
                      model: {
                        value: _vm.site.phone,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.site,
                            "phone",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "site.phone"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-text-field", {
                      attrs: { label: _vm.$t("companyName") },
                      model: {
                        value: _vm.site.company,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.site,
                            "company",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "site.company"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { flat: "", color: "primary" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.goToGoogleMapLink.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("v-icon", [_vm._v("location_on")]),
                        _vm._v(" " + _vm._s(_vm.$t("googleMap")))
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { "justify-space-between": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-text-field", {
                      attrs: { label: "EIN" },
                      model: {
                        value: _vm.site.partyId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.site,
                            "partyId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "site.partyId"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-text-field", {
                      attrs: { label: _vm.$t("email") },
                      model: {
                        value: _vm.site.email,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.site,
                            "email",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "site.email"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("vite-autocomplete", {
                      attrs: {
                        "hide-details": "",
                        items: _vm.countryCodeArray,
                        "item-text": "name",
                        "item-value": "value",
                        label: _vm.$t("country")
                      },
                      model: {
                        value: _vm.site.countryCode,
                        callback: function($$v) {
                          _vm.$set(_vm.site, "countryCode", $$v)
                        },
                        expression: "site.countryCode"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54595cf4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54595cf4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelCreateAddress.vue
// module id = null
// module chunks = 